import * as HttpService from "./http.service";
import * as URL from "./url.service";

export const getPresignedURl = (filePath) => {
  return HttpService.postWithAuth(URL.GET_PRESIGNED_URL(), { filePath });
};

export const getSignedUrl = (filePath) => {
  if (typeof filePath !== 'string' || !filePath?.length) return { status: false, entity: "" }
  return HttpService.getWithAuth(URL.GET_SIGNED_URL(filePath));
};

/**
 * V2: requests a scoped pre-signed upload URL from the backend.
 * The backend generates the unique filename and returns it alongside the SAS URL.
 *
 * @param {string} fileName   - Original filename (backend derives the unique name from it)
 * @param {string} [path]     - Optional folder prefix (e.g. 'workpackages/')
 * @param {string} [contentType] - MIME type of the file
 * @returns {Promise<{ status: boolean, entity: { url: string, fileName: string } }>}
 */
export const getPresignedUrlV2 = (fileName, path, contentType) => {
  return HttpService.postWithAuth(URL.GET_PRESIGNED_URL_V2(), { fileName, path, contentType });
};
